<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo.jpg" alt="logo图">
    </div> -->
    <p class="title">南京盛沃科技有限公司</p>
    <p class="address_tel_fax">
      <span
        >地址：南京市雨花台区软件大道180号南京大数据产业基地一号楼203室</span
      >
      <span>邮编:210012</span><br />
      <span>南京总部电话：13401978509，</span>
      <span>传真：02557839656，</span>
      <span>技术支持：18112928906</span>
    </p>
    <p class="email_wx">
      <span>邮箱：swsupport@sunwell-tech.cn</span>
    </p>
    <p class="copy">
      <a
        href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011402011057"
      >
        <img class="gongan" src="@/assets/img3/gongan.png" alt="" />
        苏公网安备 32011402011057号
      </a>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn">
        苏ICP备2022001071号
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #337ab7;
  overflow: hidden;
  text-align: center;
  padding: 50px 0;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
  text-align: center;
}
.logo img {
  width: 95px;
  margin: 0 auto;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.copy a {
  color: #d3d3d3;
}

.copy a img {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -5px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

@media screen and (max-width: 768px) {
  #footer {
    padding: 50px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue